export const DEFAULT_WAYPOINT_TESTER_SENDER_ADDRESS = 'trial@waypointmail.com';
export const DEFAULT_WAYPOINT_TESTER_SENDER_CONTACT = `Waypoint Tester <${DEFAULT_WAYPOINT_TESTER_SENDER_ADDRESS}>`;
